import React from 'react';
import Search from './Search'
import List from './List'
import * as API from 'modules/app/API'
import * as Notifications from 'fw/globals/Notifications'
import * as Help from 'modules/app/Help'

class LogsTab extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			loading: false
		}
	}

	onSearch = (rq) => {
		this.setState({ loading: true });

		API.App.get('/console/getLogs', rq,
			{
				success: (sr) => {
					this.setState({
						list: sr.data,
						loading: false
					});

					if (sr.data.items.length === 0)
						Notifications.error("No log results found.");
				},
				exception: (sr) => {
					console.log("Error retrieving support log information");
				}
			});
	}

	setHelp = () => {
		if (this.props.helpKey)
			Help.setHelp(this.props.helpKey)
		else
			Help.clearHelp();
	}

	  componentDidMount() {
		this.setHelp();
	  }

	render() {
		return (
			<React.Fragment>
				<Search onSearch={this.onSearch} />
				<hr />
				{!this.state.loading &&
				<List list={this.state.list} />}
				{this.state.loading &&
				<p>Loading...</p>}
			</React.Fragment>);
	}
}

export default LogsTab;



// WEBPACK FOOTER //
// ./src/areas/admin/console/logs/LogsTab.js